import React from "react";
import "../document.css";
// описание жизнен цикла ГОТОВО
const Lifecycle = () => {
  return (
    <div className="lifecycle-page">
      <div className="container">
        <h1 className="page-title">
          ОПИСАНИЕ ПРОЦЕССОВ, ОБЕСПЕЧИВАЮЩИХ ПОДДЕРЖАНИЕ ЖИЗНЕННОГО ЦИКЛА,
          УСТРАНЕНИЕ НЕИСПРАВНОСТЕЙ, ВЫЯВЛЕННЫХ В ХОДЕ ЭКСПЛУАТАЦИИ,
          СОВЕРШЕНСТВОВАНИЕ ПРОГРАММНОГО ОБЕСПЕЧЕНИЯ, А ТАКЖЕ ИНФОРМАЦИЯ О
          ПЕРСОНАЛЕ, НЕОБХОДИМОМ ДЛЯ ОБЕСПЕЧЕНИЯ ПОДДЕРЖКИ РАБОТОСПОСОБНОСТИ
          ПРОГРАММНОГО ОБЕСПЕЧЕНИЯ «ИММЕТРИКС»
        </h1>

        <section className="lifecycle-section">
          <h2 className="section-title">
            I. Описание процессов, обеспечивающих поддержание жизненного цикла
            программного обеспечения «Имметрикс»:
          </h2>
          <p className="section-text">
            Поддержание жизненного цикла программного обеспечения «Имметрикс»
            (далее - ПО) осуществляется за счет его сопровождения в течении
            всего периода эксплуатации и проведения обновлений, как в
            соответствии с собственным планом разработки программного
            обеспечения, так и по заявкам пользователей.
          </p>

          <h3 className="subsection-title">Цели сопровождения ПО:</h3>
          <ul className="goals-list">
            <li>
              обеспечение бесперебойной работы ПО, доступа к нему пользователей
              и ликвидации простоев в работе;
            </li>
            <li>обеспечение гарантий безопасного функционирования ПО;</li>
            <li>
              обеспечение возможности дальнейшего развития и совершенствования
              ПО.
            </li>
          </ul>

          <h3 className="subsection-title">
            Обозначенные цели достигаются посредством реализации следующих
            задач:
          </h3>
          <ul className="tasks-list">
            <li>
              консультирования пользователей и лицензиатов по вопросам
              настройки, работы, администрирования и совершенствования ПО;
            </li>
            <li>
              самостоятельного тестирования ПО с целью выявления неисправностей,
              багов и логических ошибок в его работе;
            </li>
            <li>
              самостоятельного тестирования оборудования, используемого для
              работы ПО, с целью выявления неисправностей, а также определения
              необходимости увеличения его мощности;
            </li>
            <li>
              сбора и систематизации обратной связи от пользователей и
              тестировщиков и определение приоритетов для дальнейшего развития и
              совершенствования ПО;
            </li>
            <li>
              разработки, тестирования и выпуска, путем обновлений, новых версий
              ПО;
            </li>
            <li>
              устранения неисправностей, багов и логических ошибок в работе ПО;
            </li>
            <li>
              модификации оборудования, используемого для работы ПО, и
              увеличения серверной мощности.
            </li>
          </ul>
        </section>

        <section className="lifecycle-section">
          <h2 className="section-title">
            II. Устранение неисправностей, выявленных в ходе эксплуатации ПО:
          </h2>
          <p className="section-text">
            Неисправности, баги и логические ошибки, выявленные в ходе
            эксплуатации ПО, исправляются посредством:
          </p>
          <ul className="fix-methods-list">
            <li>
              регулярное массовое автоматическое обновление ПО в соответствии с
              собственным планом разработки;
            </li>
            <li>
              единичное обновление ПО по запросу пользователя или лицензиата в
              адрес специалиста службы технической поддержки;
            </li>
          </ul>
          <p className="section-text">
            Запросы пользователей или лицензиатов на устранение неисправностей,
            выявленные в ходе эксплуатации ПО, принимаются посредством:
          </p>
          <ul className="contact-methods-list">
            <li>
              заполнения формы по ссылке{" "}
              <a href="https://codextech.ru" className="external-link">
                https://codextech.ru
              </a>
              ;
            </li>
            <li>
              по адресу электронной почты{" "}
              <a href="mailto:e.zalaev@codextech.ru" className="email-link">
                e.zalaev@codextech.ru
              </a>
              ;
            </li>
            <li>
              а также по круглосуточному номеру телефона, указанному в
              лицензионном соглашении.
            </li>
          </ul>
        </section>

        <section className="lifecycle-section">
          <h2 className="section-title">
            III. Обновление и совершенствование программного обеспечения ПО:
          </h2>
          <p className="section-text">
            Совершенствование, обновление и модификация ПО осуществляются
            посредством:
          </p>
          <ul className="update-methods-list">
            <li>
              массового автоматического обновления ПО в соответствии с
              собственным планом разработки;
            </li>
            <li>
              индивидуальное обновление ПО по запросу и под нужды конкретного
              лицензиата, в рамках согласованного с ним технического задания;
            </li>
          </ul>
          <p className="section-text">
            Запросы пользователей или лицензиатов на обновление, а также
            предложения по улучшению и доработке ПО, принимаются посредством:
          </p>
          <ul className="contact-methods-list">
            <li>
              заполнения формы по ссылке{" "}
              <a href="https://codextech.ru" className="external-link">
                https://codextech.ru
              </a>
              ;
            </li>
            <li>
              по адресу электронной почты{" "}
              <a href="mailto:e.zalaev@codextech.ru" className="email-link">
                e.zalaev@codextech.ru
              </a>
              ;
            </li>
            <li>
              а также по круглосуточному номеру телефона, указанному в
              лицензионном соглашении.
            </li>
          </ul>
        </section>

        <section className="lifecycle-section">
          <h2 className="section-title">
            IV. Перечень оказываемых услуг в рамках сопровождения программного
            обеспечения ПО:
          </h2>
          <ul className="services-list">
            <li>
              круглосуточный телефон технической поддержки, бесплатный для
              вызывающего;
            </li>
            <li>
              круглосуточная техническая поддержка в специализированном чате и
              прочих каналах коммуникации;
            </li>
            <li>
              обеспечение экстренной поддержки со стороны системного
              администрирования;
            </li>
            <li>
              бесплатное исправление логических ошибок и багов в программном
              обеспечении;
            </li>
            <li>
              регулярное развитие и выпуск новых версий базового программного
              обеспечения;
            </li>
            <li>
              возможность платного обновления на новые версии программного
              обеспечения в тех случаях, когда это не требуется по условиям
              исправления логических ошибок;
            </li>
            <li>
              платное сервисное обслуживание ПО в течении всего срока
              эксплуатации системы;
            </li>
            <li>
              платные модификации и доработки ПО по техническому заданию
              клиента;
            </li>
            <li>платная настройка ПО по техническому заданию клиента;</li>
          </ul>
        </section>

        <section className="lifecycle-section">
          <h2 className="section-title">
            V. Информация о персонале, необходимом для обеспечения поддержки
            работоспособности ПО
          </h2>
          <ol className="personnel-list">
            <li>
              <strong>Специалист технической поддержки</strong> – первая линия
              поддержки клиентов по всем каналам коммуникации (телефон, чаты,
              электронная), закрытие trouble tickets;
            </li>
            <li>
              <strong>Системный администратор</strong> – обеспечение
              работоспособности серверов, техническая поддержка второго уровня,
              backup, обеспечение безопасной работы программного обеспечения;
            </li>
            <li>
              <strong>Frontend-разработчик</strong> – устранение визуальных
              багов программного обеспечения, доработка визуальной части
              программного обеспечения, поддержка API;
            </li>
            <li>
              <strong>Backend-разработчик</strong> – устранение архитектурных
              багов программного обеспечения, доработка архитектурной и
              логической части программного обеспечения, поддержка UI;
            </li>
            <li>
              <strong>Android-разработчик</strong> – поддержка android клиента;
            </li>
            <li>
              <strong>Специалист отдела внедрения</strong> – настройка
              программного обеспечения по техническому заданию клиента на
              платной основе.
            </li>
          </ol>
        </section>

        <section className="lifecycle-section">
          <h2 className="section-title">
            VI. Информация о фактическом адресе размещения разработчиков, службы
            технической поддержки и инфраструктуры разработки ПО:
          </h2>
          <p className="section-text">
            Разработчики, служба технической поддержки и инфраструктура для
            разработки ПО размещаются по адресу 420500, РОССИЯ, Республика
            Татарстан (Татарстан), ВЕРХНЕУСЛОНСКИЙ, ИННОПОЛИС, ГОРОД ИННОПОЛИС,
            ул, УНИВЕРСИТЕТСКАЯ, Д. 5.
          </p>
          <p className="section-text">
            Инфраструктура обеспечивающая работу облачной версии программного
            обеспечения находятся на территории Российской Федерации по адресу:
            111024, г. Москва, ул. Авиамоторная, 69 (Data Pro I). Провайдером
            указанной услуги является ООО «Хостинг-технологии» ИНН 7721833428 на
            основании заключенного с Заявителем договора от 11.09.2025 №
            2257/427120/25, в соответствии с правовой и технической
            документацией, размещенной в сети Интернет по адресам:{" "}
            <a href="https://vdsina.ru" className="external-link">
              https://vdsina.ru
            </a>
            ,{" "}
            <a href="https://vdsina.ru/documents" className="external-link">
              https://vdsina.ru/documents
            </a>
            .
          </p>
          <p className="section-text">
            Запросы пользователей или лицензиатов на техническую поддержку
            принимаются посредством:
          </p>
          <ul className="contact-methods-list">
            <li>
              заполнения формы по ссылке{" "}
              <a href="https://codextech.ru" className="external-link">
                https://codextech.ru
              </a>
              ;
            </li>
            <li>
              по адресу электронной почты{" "}
              <a href="mailto:e.zalaev@codextech.ru" className="email-link">
                e.zalaev@codextech.ru
              </a>
              ;
            </li>
            <li>
              а также по круглосуточному номеру телефона, указанному в
              лицензионном соглашении.
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Lifecycle;
